'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var DataRetrievalService = function DataRetrievalService($q, $http, $log, FetchUrl, dataRetrievalCacheService, constants, navigationHistoryService, softLimitService, momentService, App) {
  var MAX_GET_FILTER_LENGTH = 1500;
  var NO_FILTER_ID_NEEDED_PROMISE = $q.when({
    data: {
      _id: undefined
    }
  });
  var customValueInsteadOfNotFoundError = {
    '/api/configuration/hep?type=UserDefinedReferenceDataMarketProfile': [],
    '/api/configuration/hep?type=UserDefinedReferenceDataFlightProfile': []
  };
  function prepareFetchUrl(url, filter, filterId, sortBy, sortOrder, pageLimit, requestOffset, requestParams, page, maxLimit) {
    var MAX_PAGE_LIMIT = 100000;
    if (_.includes(url, 'linkedfbc')) {
      MAX_PAGE_LIMIT = -1;
    }
    // max limit of records we want to accept from the REST API endpoint
    var MAX_LIMIT = maxLimit || App.maxLimit;
    var config = {};
    config.url = url;
    config.params = {};
    if (page !== undefined) {
      config.params.page = page;
    }
    if (!_.isEmpty(sortBy)) {
      config.params.sortBy = sortBy;
    }
    if (!_.isEmpty(sortOrder)) {
      config.params.sortOrder = sortOrder;
    }
    if (!_.isNil(requestOffset)) {
      config.params.requestOffset = requestOffset;
    }
    config.params.pageLimit = !_.isNil(pageLimit) ? pageLimit : MAX_PAGE_LIMIT;
    config.params.maxLimit = MAX_LIMIT;
    if (!_.isEmpty(filter)) {
      config.params.filter = filter;
    }
    if (!_.isEmpty(filterId)) {
      config.params.filterId = filterId;
    }
    _.extend(config.params, requestParams);
    return new FetchUrl(config);
  }
  function makeRequest(fetchUrlObject, etag, httpMethod, mimeType, cancelPromise) {
    if (httpMethod && httpMethod === 'POST') {
      var url, payload;
      if (mimeType === constants.MIME_TYPE.JSON) {
        url = fetchUrlObject.getUrlWithQueryAsString(['filter']);
        payload = {
          filter: fetchUrlObject.params.filter
        };
      } else if (mimeType === constants.MIME_TYPE.FORM_URLENCODED) {
        url = fetchUrlObject.getUrlAsString();
        payload = fetchUrlObject.getQueryAsString();
      } else {
        throw new Error('Unsupported MIME type: ' + mimeType);
      }
      return $http(createCfgForHttpPost(url, mimeType, etag, payload));
    } else {
      var urlQueryString = fetchUrlObject.toString();
      return $http(createCfgForHttpGet(urlQueryString, etag, cancelPromise));
    }
  }
  function createCfgForHttpPost(url, mimeType, etag, payload) {
    return {
      cache: false,
      method: 'POST',
      url: url,
      headers: {
        'If-None-Match': etag,
        'Content-Type': mimeType
      },
      data: payload
    };
  }
  function createCfgForHttpGet(url, etag, cancelPromise) {
    return {
      cache: false,
      method: 'GET',
      url: url,
      headers: {
        'If-None-Match': etag
      },
      timeout: cancelPromise
    };
  }
  function cannotBeNotFound(response) {
    var result = true;
    var possibleEmptyResponseKeys = _.keys(customValueInsteadOfNotFoundError);
    _.forEach(possibleEmptyResponseKeys, function (url) {
      if (response.config.url.indexOf(url) > -1) {
        result = false;
        return false;
      }
    });
    return result;
  }
  function shouldBeRedirected(screenModeConfig) {
    var REDIRECT_CONF = {
      'MARKET_SCREEN': ['market-product-group', 'service'],
      'FLIGHT_SCREEN': ['class', 'segment-classes', 'service']
    };
    return _.includes(REDIRECT_CONF[screenModeConfig.screen], screenModeConfig.mode);
  }
  function appendDataDetails(data) {
    return _.isObject(data) ? ', HTTP error code: ' + data.code + ', message: ' + data.message : '';
  }
  function onRequestErrorHandler(screenModeConfig, ignoredErrorStatuses, response) {
    ignoredErrorStatuses = ignoredErrorStatuses || [];
    if (response.status === 304) {
      //if 304 - return response to success handler
      return response;
    }
    var logErrorStatus = ignoredErrorStatuses.indexOf(response.status) === -1;
    if (logErrorStatus) {
      if (response.status === 500 || response.status === 404 && cannotBeNotFound(response)) {
        if (response.data.timeout !== undefined) {
          $log.warn('DataRetrievalService: onRequestErrorHandler - ' + response.data.message);
          toastr.error('Operation exceeded time limit (' + response.data.timeout + ' seconds). Please narrow your search.');
          redirectToPreviousMode(screenModeConfig);
        } else {
          $log.error('DataRetrievalService: onRequestErrorHandler - There was a critical data error: ' + response.statusText + appendDataDetails(response.data));
          toastr.error('There was a critical data error: ' + response.statusText);
        }
      } else if (response.status === 413) {
        $log.warn('DataRetrievalService: onRequestErrorHandler - Too much data requested');
        toastr.error('Too much data requested. Please narrow your search.');
        redirectToPreviousMode(screenModeConfig);
      } else if (response.status === -1 && _.isEqual(response.xhrStatus, 'error')) {
        $log.warn('DataRetrievalService: onRequestErrorHandler - Too much data requested');
        toastr.error('Too much data requested. Please narrow your search.');
        redirectToPreviousMode(screenModeConfig);
      }
    }
    return $q.reject();
  }
  function redirectToPreviousMode(screenModeConfig) {
    if (shouldBeRedirected(screenModeConfig)) {
      invalidateRawCache();
      navigationHistoryService.moveToPreviousMode();
    }
  }
  function onSuccessHandler(fetchUrl, cachedData, cacheRawData, etag, response) {
    var data = response.data;
    var serverEtag = response.headers('etag');

    //We deep clone the data so as to cache a copy, rather than a reference to the grid data object,
    //which can be modified by the user and thus no longer accurately reflect the original request result.
    if (etag && response.status === 304) {
      //case when response from server is empty and we should use data from cache.
      dataRetrievalCacheService.putData(fetchUrl, _.cloneDeep(cachedData), cacheRawData, etag);
      data = cachedData;
    } else if (cacheRawData || serverEtag) {
      //status is 200 and there is e-tag from the server or data should be cached
      dataRetrievalCacheService.putData(fetchUrl, _.cloneDeep(data), cacheRawData, serverEtag);
    }
    $log.debug('After retrieving data...');
    return data;
  }
  function onErrorHandler(url) {
    return _.has(customValueInsteadOfNotFoundError, url) ? customValueInsteadOfNotFoundError[url] : $q.reject();
  }
  function isFilterLengthExceeded(filter) {
    return _.size(filter) > MAX_GET_FILTER_LENGTH;
  }
  function postFilterIfLengthExceeded(filter, httpMethod) {
    var isGetRequest = httpMethod === constants.HTTP_METHOD.GET;
    if (isGetRequest && isFilterLengthExceeded(filter)) {
      var cachedFilterPromise = dataRetrievalCacheService.getData(filter);
      if (cachedFilterPromise) {
        return cachedFilterPromise;
      }
      var created = momentService.now(momentService.FIELD.EVENT_TIME_STAMP).toString();
      var payload = {
        filter: filter,
        createdAt: created
      };
      var cfgObject = createCfgForHttpPost('/api/configured/filter', 'application/json', undefined, payload);
      var filterPromise = $http(cfgObject);
      dataRetrievalCacheService.putData(filter, filterPromise, true, null);
      return filterPromise;
    } else {
      return NO_FILTER_ID_NEEDED_PROMISE;
    }
  }
  function retrieveDataOnce(url, filter, sortBy, sortOrder, pageLimit, requestOffset, cacheRawData, requestParams, page, httpMethod, mimeType, ignoredErrorStatuses, cancelPromise, screenModeConfig, maxLimit) {
    var fetchUrlObject = prepareFetchUrl(url, filter, undefined, sortBy, sortOrder, pageLimit, requestOffset, requestParams, page, maxLimit);
    var urlQueryString = fetchUrlObject.toString();
    var cachedData = dataRetrievalCacheService.getData(urlQueryString);
    if (cacheRawData && dataRetrievalCacheService.hasRawDataCache(urlQueryString)) {
      return $q.when(cachedData);
    } else {
      $log.debug('Before retrieving data...');
      var etag = dataRetrievalCacheService.getEtag(urlQueryString);

      // url can include ?filter=... (defined in DataRetrieverFactory),
      // we need to merge it with this function's filter argument first to POST it later
      var mergedFilter = fetchUrlObject.getAllParams().filter;
      var promise = postFilterIfLengthExceeded(mergedFilter, httpMethod).then(function (result) {
        var filterId = result.data._id;
        var newFilter = filterId ? undefined : filter;
        var newFetchUrlObject = prepareFetchUrl(url, newFilter, filterId, sortBy, sortOrder, pageLimit, requestOffset, requestParams, page, maxLimit);
        return makeRequest(newFetchUrlObject, etag, httpMethod, mimeType, cancelPromise)["catch"](onRequestErrorHandler.bind(null, screenModeConfig, ignoredErrorStatuses)).then(onSuccessHandler.bind(null, urlQueryString, cachedData, cacheRawData, etag), onErrorHandler.bind(null, url));
      });
      if (cacheRawData) {
        dataRetrievalCacheService.putData(urlQueryString, promise, true, null);
      }
      return promise;
    }
  }
  function makeMultiRequests(deferred, url, filter, sortBy, sortOrder, pageLimit, requestOffset, cacheRawData, requestParams, threadsQuantity, pageFrom, promises, httpMethod, mimeType) {
    for (var i = pageFrom; i < pageFrom + threadsQuantity; i++) {
      promises.push(retrieveDataOnce(url, filter, sortBy, sortOrder, pageLimit, requestOffset, cacheRawData, requestParams, i, httpMethod, mimeType));
    }
    var rejected = false;
    $q.all(promises)["catch"](function () {
      deferred.reject();
      rejected = true;
    });
    function onLastPromiseSuccess(data) {
      if (data.totalCount !== undefined && data.totalCount > pageLimit && !rejected) {
        makeMultiRequests(deferred, url, filter, sortBy, sortOrder, pageLimit, requestOffset, cacheRawData, requestParams, threadsQuantity, i, promises, httpMethod, mimeType);
      } else {
        deferred.resolve($q.all(promises));
      }
    }
    var lastPromise = promises[promises.length - 1];
    if (_.isFunction(lastPromise.then)) {
      lastPromise.then(onLastPromiseSuccess);
    } else {
      onLastPromiseSuccess(lastPromise);
    }
    return deferred;
  }
  var moveBackThroughNavigationHistory = _.debounce(navigationHistoryService.moveToPreviousMode, 200);
  function cancelledSoftLimitHandler(screenModeConfig, canceller, deferred) {
    if (shouldBeRedirected(screenModeConfig)) {
      invalidateRawCache();
      moveBackThroughNavigationHistory();
    }
    canceller.resolve();
    deferred.reject();
  }

  /**
   *
   * @param url - URL the data will be taken from
   * @param filter - RSQL query
   * @param sortBy - name of fields to sort by
   * @param sortOrder - order of sorting (ASC,DESC)
   * @param pageLimit - number of elements in the response
   * @param cacheRawData - we are using external cache instead of $http caching, because we can invalidate it in a simple way
   * @param requestParams - additional request parameters (?a=1&b=2)
   * @param threadsQuantity - number of threads used on the server side to handle the requests (= number of requests made by UI)
   * @param dynamicPageLimit - true/false - if true, ask for count and the first page, then ask for the rest of the data
   * @param httpMethod - eg. GET
   * @param mimeType - if httpMethod === POST, use this value as content type, eg. application/json
   * @param ignoredErrorStatuses - a list of statuses that will NOT be logged or shown as a toaster message if they appear
   * @param screenModeConfig - object storing screen and mode from where request is triggered
   * @param maxLimit - maximum limit of records we want to get from REST API endpoint
   * @param softLimit - soft limit of records we want to get from REST API endpoint
   * @returns {Promise}
   */
  function retrieveData(url, filter, sortBy, sortOrder, pageLimit, cacheRawData, requestParams, threadsQuantity, dynamicPageLimit, httpMethod, mimeType, ignoredErrorStatuses, screenModeConfig, maxLimit, softLimit) {
    if (threadsQuantity > 1) {
      var deferred = $q.defer();
      var canceller = $q.defer();
      if (dynamicPageLimit) {
        var count = retrieveDataOnce(url, filter, sortBy, sortOrder, 0, undefined, cacheRawData, requestParams, 0, httpMethod, mimeType, ignoredErrorStatuses, null, screenModeConfig, maxLimit);
        var updatedIgnoredErrorStatuses = ignoredErrorStatuses ? _.concat(ignoredErrorStatuses, 413) : [413];
        var firstPage = retrieveDataOnce(url, filter, sortBy, sortOrder, pageLimit, undefined, cacheRawData, requestParams, 0, httpMethod, mimeType, updatedIgnoredErrorStatuses, canceller.promise, screenModeConfig, maxLimit);
        count.then(function (data) {
          data.totalCount = data.totalCount || 0;
          if (data.totalCount <= pageLimit) {
            return deferred.resolve($q.all([firstPage]));
          }
          var proceedFn = function proceedFn() {
            var newPageLimit = Math.ceil((data.totalCount - pageLimit) / threadsQuantity);
            makeMultiRequests(deferred, url, filter, sortBy, sortOrder, newPageLimit, pageLimit, cacheRawData, requestParams, threadsQuantity, 1, [firstPage], httpMethod, mimeType);
          };
          softLimitService.confirm(data.totalCount, softLimit).then(proceedFn, cancelledSoftLimitHandler.bind(undefined, screenModeConfig, canceller, deferred));
        })["catch"](function () {
          canceller.resolve();
          return deferred.reject();
        });
      } else {
        makeMultiRequests(deferred, url, filter, sortBy, sortOrder, pageLimit, undefined, cacheRawData, requestParams, threadsQuantity, 1, [], httpMethod, mimeType);
      }
      return deferred.promise;
    } else {
      return retrieveDataOnce(url, filter, sortBy, sortOrder, pageLimit, undefined, cacheRawData, requestParams, undefined, httpMethod, mimeType, ignoredErrorStatuses, null, screenModeConfig, maxLimit);
    }
  }
  function invalidateRawCache() {
    dataRetrievalCacheService.invalidateRawCache();
  }
  return {
    retrieveData: retrieveData,
    invalidateRawCache: invalidateRawCache
  };
};
DataRetrievalService.$inject = ['$q', '$http', '$log', 'FetchUrlFactory', 'DataRetrievalCacheService', 'DataRetrieverConstantsService', 'NavigationHistoryService', 'SoftLimitService', 'MomentService', 'App'];
module.exports = DataRetrievalService;